export enum AGENT_RELATIONSHIP {
  "EMPLOYEE" = 'Z00060',
  "AUH" = 'Z00057',
  "AUM" = 'Z00056',
  "HBA" = 'Z00055',
  "AIA" = 'Z00051',
  "BROKER" = 'Z00052',
  "MERCHANT" = 'Z00059'
};
